module.exports = __webpack_public_path__ + "img/invoice-icon.8501c438.svg";